import React from 'react'
import UpgradeToGetStarted from '../../components/UpgradeToGetStarted/UpgradeToGetStarted'

const FinancialsInvoices = () => {
    return (
        <>
            <UpgradeToGetStarted
                imageSrc="/assets/images/blank-page/user-invoices.png"
                imageAlt="user invoices"
                heading="Invoices"
                description="Create, customize, and send professional invoices — link billable hours, expenses, and project details to get paid faster and stay organized."
                lockIconSrc="./assets/images/app-activity/insights/lock-icon.svg"
                promoText="Schedule a call with our sales team to discover more about Invoices."
                buttonText="Upgrade to get started"
                showTextContent={true}
            />
        </>
    )
}

export default FinancialsInvoices
